export const getFullPhoneNumber = (phoneCode, phoneNumber) => {
  const code = phoneCode || "";
  const number = (phoneNumber || "").replace(/^\+/, "");
  return `${code}${number}`;
};

export const getPersonFullPhoneNumber = (person) => {
  return getFullPhoneNumber(person?.phoneCode, person?.phoneNumber);
};

export const formatForWhatsApp = (phoneCode, phoneNumber) => {
  const fullNumber = getFullPhoneNumber(phoneCode, phoneNumber);
  return fullNumber.replace(/^\+/, "");
};


export const cleanPhoneForInput = (phone, phoneCode = "+234") => {
  if (!phone) return "";
  const codeDigits = phoneCode.replace(/\D/g, "");
  let cleaned = phone.trim();
  if (codeDigits && cleaned.replace(/\D/g, "").startsWith(codeDigits)) {
    cleaned = cleaned.replace(new RegExp(`^\\+?${codeDigits}`), "");
  }
  return cleaned;
};

export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber || typeof phoneNumber !== "string") return false;
  const digitsOnly = phoneNumber.replace(/\D/g, "");
  return digitsOnly.length >= 7 && digitsOnly.length <= 15;
};

export const formatFullPhone = (phoneCode, phoneNumber) => {
  if (!phoneNumber) return "";
  const trimmed = phoneNumber.trim();
  if (trimmed.startsWith("+")) return trimmed;
  const codeDigits = (phoneCode || "+234").replace(/\D/g, "");
  const numDigits = trimmed.replace(/\D/g, "");
  if (numDigits.startsWith(codeDigits)) {
    return `+${numDigits}`;
  }
  const cleanNum = numDigits.replace(/^0+/, "");
  return `+${codeDigits}${cleanNum}`;
};

